import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';

export const getTenantKey = (): string | undefined => {
  const raw = Cookies.get(TENANT_STORAGE_KEY);
  if (!raw) return undefined;
  try {
    return JSON.parse(raw)?.key;
  } catch {
    return undefined;
  }
};
